import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import i18n from './i18n';
import VueMeta from 'vue-meta'
import VueClipboard from 'vue-clipboard2'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import './plugins/notify';

Vue.config.productionTip = false

Vue.use(VueMeta, {
    refreshOnceOnNavigation: true,
});
Vue.use(VueClipboard)
Vue.use(VueSweetalert2)

new Vue({
    vuetify,
    router,
    i18n,
    render: h => h(App)
}).$mount('#app')